import {
  DYNAMIC_CALLER_ID_NAME,
  DYNAMIC_CALLER_ID_NUMBER,
} from '@components/OutboundCallerIdSelection/constants';
import { Tooltip } from '@components/Tooltip';
import maskPhoneNumber from '@lib/utils/maskPhoneNumber';
import { BodyText, Icon } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC } from 'react';
import styles from './CallerIdDisplay.module.css';
import strings from '../../../strings';
import { inboxLocators } from '@locators/inbox';

interface CallerCardProps {
  callerName?: string;
  callerId?: string;
  className?: string;
}

export const CallerIdDisplay: FC<CallerCardProps> = ({
  className,
  callerId,
  callerName,
}) => {
  if (callerId === DYNAMIC_CALLER_ID_NUMBER) {
    return (
      <div className={styles.tooltipContainer}>
        <BodyText
          size='small'
          className={styles.name}
          data-testid={inboxLocators.callBar.agentCallerIdName}
        >
          {DYNAMIC_CALLER_ID_NAME}
        </BodyText>
        <Tooltip placement='top-start' text={strings.dynamicCallerIdTooltip}>
          <Icon name='info' size='16' />
        </Tooltip>
      </div>
    );
  }

  return (
    <div className={classNames(styles.container, className)}>
      <Tooltip
        placement='top-start'
        text={callerName ?? ''}
        triggerClassName={styles.name}
        innerSpanClassName={styles.name}
      >
        <BodyText
          el='span'
          bold
          size='medium'
          className={styles.name}
          data-testid={inboxLocators.callBar.agentCallerIdName}
        >
          {callerName}
        </BodyText>
      </Tooltip>

      {callerId && (
        <BodyText
          el='span'
          subdued
          size='small'
          className={styles.number}
          data-testid={inboxLocators.callBar.agentCallerIdNumber}
        >
          {maskPhoneNumber(callerId)}
        </BodyText>
      )}
    </div>
  );
};
